import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../../utils/cn';

import styles from './RadioGroup.module.scss';

function RadioGroup({
  groupName, entries, selected, setSelected, setFieldValue, fieldName, large, horizontalScroll, required,
}) {
  const handleChange = (input) => {
    const value = input.target.value === selected ? null : input.target.value;
    if (required && !value) return;
    setSelected(value);
    setFieldValue(fieldName, value);
  };

  return (
    <div className={`${horizontalScroll ? styles.group_wrapper : 'f-wrap'} d-flex a-center`}>
      {entries.map((entry, i) => (
        <div key={i} className={`${styles.choice} ${large ? styles.large : ''}`}>
          <input
            type="checkbox"
            id={`${groupName}_${entry.name}`}
            name={groupName}
            value={entry.name}
            checked={selected === entry.name}
            onChange={handleChange}
          />
          <label
            htmlFor={`${groupName}_${entry.name}`}
            className={cn([horizontalScroll ? '' : 'm-t-5 m-b-5', 'font-secondary'])}
          >
            {entry.label}
          </label>
        </div>
      ))}
    </div>
  );
}

RadioGroup.propTypes = {
  groupName: PropTypes.string.isRequired,
  entries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selected: PropTypes.string,
  setSelected: PropTypes.func,
  setFieldValue: PropTypes.func,
  fieldName: PropTypes.string,
  large: PropTypes.bool,
  horizontalScroll: PropTypes.bool,
  required: PropTypes.bool,
};

RadioGroup.defaultProps = {
  large: false,
  selected: '',
  setSelected: () => {},
  setFieldValue: () => {},
  fieldName: '',
  horizontalScroll: false,
  required: false,
};

export default RadioGroup;
